import app from 'firebase/app';
import 'firebase/firestore';
import 'firebase/storage';
import 'firebase/auth';

const config = {
    apiKey: "AIzaSyBaYYdepcXcc3fzaNNJH4la5ORCbTY7fik",
    authDomain: "carpet-king.firebaseapp.com",
    databaseURL: "https://carpet-king.firebaseio.com",
    projectId: "carpet-king",
    storageBucket: "carpet-king.appspot.com",
    messagingSenderId: "233267539488",
    appId: "1:233267539488:web:a9306ba116fe71ff"
};

app.initializeApp(config);


const storage = app.storage();
const firestore = app.firestore();
const auth = app.auth();
firestore.enablePersistence({ experimentalTabSynchronization: true })

export {
    auth,
    firestore,
    storage,
    app as default
};